import { Box, makeStyles, TableProps, Table } from '@material-ui/core';
import React from 'react';

export type TableNoResultProps = TableProps & {
    itemCount: number
};

export function TableNoResult ({ itemCount, ...props }: TableNoResultProps) {
    const cls = useStyles();

    return itemCount > 0 
        ? <Table {...props} size="small" className={cls.table} />
        : <Box className={cls.box}>Nenhum Resultado</Box>
}

const useStyles = makeStyles(theme => ({
    box: {
        padding: theme.spacing(2),
        fontStyle: 'italic',
        textAlign: 'center',
        width: '100%',
    },

    table: {
        width: '100%',
    }
}));